module.exports = __webpack_public_path__ + "static/media/19.68bb1147.svg";